import { faker } from '@faker-js/faker';

import type { OneOffPaymentNoticePostResponse } from '../types/OneOffPaymentNoticePostResponse';

export function createOneOffPaymentNoticePostResponse(
  data: NonNullable<Partial<OneOffPaymentNoticePostResponse>> = {}
): NonNullable<OneOffPaymentNoticePostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
